<!--
 * @Author: 韩杰
 * @Date: 2022-04-19 09:54:32
 * @LastEditTime: 2022-04-21 15:19:47
 * @LastEditors: Please set LastEditors
 * @Description: 用于缩略图展示
 * @FilePath: \智建校\src\components\thumbnail\index.vue
-->
<template>
  <div class="thumbnail">
    <div
      v-if="direction==='horizontal'"
      ref="horizontal"
      class="horizontal thumbnailBox">
      <div
        v-for="(item,index) in imgList"
        :key="index"
        ref="horizontalItem"
        :style="horizontalItemStyle(index)"
        class="horizontalItem"
      >
        <!-- 图片样式从外传入 -->
        <slot :item="item" :index="index" name="imgItem" />
      </div>

      <div
        v-if="horizontalLeftShow"
        class="handlePrev btn"
        @click="operationBtn('left')">
        <slot name="leftBtn">
          <div>
            <i class="el-icon-arrow-left" />
          </div>
        </slot>
      </div>
      <div
        v-if="horizontalRightShow"
        class="handleNext btn"
        @click="operationBtn('right')">
        <slot name="rightBtn">
          <div>
            <i class="el-icon-arrow-right" />
          </div>
        </slot>
      </div>
    </div>
    <div
      v-if="direction==='vertical'"
      ref="vertical"
      class="vertical thumbnailBox">
      >
      竖向
    </div>
  </div>
</template>

<script>
export default {
  name: 'Thumbnail',
  components: {},
  props: {
    /**
     * @description: 用于缩略图展示
     * @param {*} direction 缩略图方向,可选值horizontal(横向)/vertical(竖向),默认horizontal
     * @param {*} imgList 图片数据
     * @param {*} interval (必填项)imgItem 间的间隔
     * @param {*} itemWidth(必填项) imgItem width+border
     * @param {*} itemHeight(必填项) imgItem height+border
     * @param {*} activeIndex 默认选中项
     * @param {*} paddingSize 盒子填充尺寸
     * @param {*} bgColor 盒子默认背景色
     * @return {*}
     */
    direction: {
      type: String,
      default: 'horizontal'
    },
    activeIndex: {
      type: [Number, Object]
    },
    imgList: {
      type: Array,
      default: () => [],
      required: true
    },
    interval: {
      type: Number,
      required: true
    },
    itemWidth: {
      type: Number,
      required: true
    },
    itemHeight: {
      type: Number,
      required: true
    },
    paddingSize: {
      type: Number,
      default: 2
    },
    bgColor: {
      type: String,
      default: 'white'
    }
  },
  data() {
    return {
      horizontalSize: 0, // 横向滚动范围容器宽度
      verticalSize: 0, // 纵向滚动范围容器高度
      portable: 0 // 滚动多少次


    }
  },
  computed: {
    // 每个item实际所占尺寸
    itemSize() {
      if (this.direction === 'horizontal') {
        return this.itemWidth + this.interval + (this.paddingSize * 2)
      } else {
        return this.itemHeight + this.interval + (this.paddingSize * 2)
      }
    },
    // 滚动区域实际尺寸
    domeSize() {
      if (this.direction === 'horizontal') {
        return this.imgList.length * this.itemSize
      } else {
        return this.imgList.length * this.itemSize
      }
    },
    // 左按钮出现的时机
    horizontalLeftShow() {
      return true
      // if (this.domeSize <= this.horizontalSize) return false
      // if (this.portable === 0) {
      //   return false
      // } else {
      //   return true
      // }
    },
    // 右按钮出现的时机
    horizontalRightShow() {
      return true
      // if (this.domeSize <= this.horizontalSize) return false
      // const num = Math.floor((this.horizontalSize - (this.paddingSize * 2)) / this.itemSize)
      // const por = Math.abs(this.portable)
      // const flag = por >= this.imgList.length - num + 6
      // if (flag) return false
      // return true
    }

  },
  watch: {
    activeIndex: {
      handler(val, oldVal) {
        if (val || val === 0) {
        //   this.portable = -val

          // if (val > oldVal) {
          //   if (oldVal === 0 && val === this.imgList.length - 1) {
          //     this.portable = -(this.imgList.length - num)
          //   } else {
          //     this.portable = -val
          //   }
          // } else {
          //   this.portable = -val
          // }

          if (val == 0 && oldVal !== 0) {
            this.portable = 0
          }
        }
      },
      deep: true
      // immediate: true
    }
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.getSize()
    })
    window.onresize = () => {
      return (() => {
        this.getSize()
      })()
    }
  },
  beforeDestroy() {
    window.onresize = null
  },
  methods: {
  /**
   * @description: 取dom元素高度
   * @param {*}
   * @return {*}
   */
    getSize() {
      if (this.direction === 'horizontal') {
        const horizontal = this.$refs.horizontal
        this.horizontalSize = horizontal.clientWidth
      } else {
        const vertical = this.$refs.vertical
        this.verticalSize = vertical.clientHeight
      }
    },
    /**
   * @description: 点击轮播按钮
   * @param {*}type left/right/top/bottom
   * @return {*}
   */
    operationBtn(type) {
      console.log(this.portable, this.imgList.length)
      if (type === 'left') {
        if (this.portable != 0) {
          this.portable += 1
        }
      }
      if (type === 'right') {
        if (this.imgList.length > 6) {
          if (this.portable !== 0 - this.imgList.length + 6) {
            this.portable -= 1
          }
        }
      }
    },
    /**
     * @description: 点击之后的回调
     * @param {*}index 点击图片列表的索引
     * @return {*}
     */
    handleControl(index) {
      this.$emit('handleControl', index)
    },
    // 间隔样式
    horizontalItemStyle(index) {
      const width = this.itemSize * this.portable
      const obj = {
        transform: 'translateX(' + width + 'px)',
        transition: 'transform 0.4s'
      }
      if (index !== this.imgList.length - 1) {
        obj.marginRight = `${this.interval}px`
      }
      if (this.paddingSize) {
        obj.padding = this.paddingSize + 'px'
      }
      if (this.bgColor) {
        obj.backgroundColor = this.bgColor
      }
      if (this.activeIndex === index) {
        obj.backgroundColor = 'yellow'
      }
      return obj
    }
  }
}
</script>

<style lang="scss" scoped>
.thumbnail{
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
  .horizontal{
    // width: 100%;
    width: calc(100% - 56px);
    margin: 0 auto;
    padding-left: 9px;
    height: 100px;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    overflow: hidden;
      .btn{
        position: absolute;
        width: 28px;
        height: 28px;
        background: rgba($color: #000, $alpha: .5);
        z-index: 20;
        border-radius: 50%;
        color: #fff;
        font-size: 14px;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        // display: none;
         display: flex;
      }
      .handlePrev{
        // left: -10px;
        left: 0;

      }
      .handleNext{
        // right: -10px;
        right: 0;
      }
    &:hover .btn{
      display: flex;
    }
  }

}
</style>
